import React from "react";
import "./styles.scss";
function AppHeader() {
  return <div className="header-container-main nav-mobile"></div>;
}

export default AppHeader;
